import { CategoryIcon, resolveCategoryForIcon, getCategoryBreadcrumb } from "../../../lib/categoryIcons";
import { getArticleStatus, STATUS_CLASSES } from "../../../lib/stockDisplay";
import { StockArticleActions } from "../../../components/StockArticleActions";
import { AlertTriangle } from "lucide-react";

// Modèle 2 — Tableau dense : maximum d'informations visibles sans défiler,
// une ligne par article.
export function DenseTableView({ articles, categories, isTestMode, user, canEditAnyStockField, canTransfer, onEdit, onTransfer, onDelete, uploadsBase }) {
  return (
    <div className="rounded-xl border border-border bg-card overflow-x-auto" data-testid="stock-view-tableau">
      <table className="w-full text-sm min-w-[760px]">
        <thead className="bg-secondary text-left">
          <tr>
            <th className="p-2 w-12"></th>
            <th className="p-3">Article</th>
            <th className="p-3">Catégorie</th>
            <th className="p-3">Code</th>
            <th className="p-3 text-right">Quantité</th>
            <th className="p-3 text-right">Prix TTC</th>
            <th className="p-3">Statut</th>
            <th className="p-3 w-24"></th>
          </tr>
        </thead>
        <tbody>
          {articles.map((a) => {
            const s = getArticleStatus(a, isTestMode);
            const cls = STATUS_CLASSES[s.key];
            return (
              <tr
                key={a.id} className="border-t border-border hover:bg-secondary/40 cursor-pointer group"
                onClick={() => canEditAnyStockField && onEdit(a)} data-testid={`stock-table-row-${a.id}`}
              >
                <td className="p-2">
                  <div className="w-8 h-8 rounded-md bg-secondary flex items-center justify-center overflow-hidden">
                    {a.photo_url ? (
                      <img src={`${uploadsBase}${a.photo_url}`} alt={a.nom} className="w-full h-full object-cover" />
                    ) : (
                      <CategoryIcon category={resolveCategoryForIcon(categories, a.categorie)} uploadsBase={uploadsBase} size={15} className="text-muted-foreground" />
                    )}
                  </div>
                </td>
                <td className="p-3 font-medium">
                  {a.nom}
                  {a.prix_vente_auto && !s.isOutOfStock && (
                    <AlertTriangle size={11} className="inline ml-1.5 text-destructive" />
                  )}
                </td>
                <td className="p-3 text-muted-foreground">{getCategoryBreadcrumb(categories, a.categorie)}</td>
                <td className="p-3 font-mono text-xs text-muted-foreground">{a.code || a.id.slice(-6)}</td>
                <td className={`p-3 text-right font-mono ${cls.text}`}>
                  {a.quantite}
                  {isTestMode && a.quantite_production !== undefined && (
                    <span className="block text-[10px] text-muted-foreground font-normal">(prod : {a.quantite_production})</span>
                  )}
                </td>
                <td className="p-3 text-right font-mono font-semibold">{Number(a.prix_ttc ?? a.prix ?? 0).toFixed(2)} €</td>
                <td className="p-3">
                  <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold ${cls.badgeBg} ${cls.badgeText}`}>
                    {s.label}
                  </span>
                </td>
                <td className="p-3">
                  <StockArticleActions
                    article={a} user={user} canEditAnyStockField={canEditAnyStockField} canTransfer={canTransfer}
                    onEdit={onEdit} onTransfer={onTransfer} onDelete={onDelete}
                    className="flex gap-1 opacity-0 group-hover:opacity-100 justify-end"
                  />
                </td>
              </tr>
            );
          })}
          {articles.length === 0 && (
            <tr><td colSpan={8} className="p-6 text-center text-sm text-muted-foreground">Aucun article.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
